// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3BR7B","question":"styles_question__3dnCv","description":"styles_description__1d9Tk"};